<div *ngIf="parentOptions?.length > 0">
    <icc-select
        [value]="parent?.id"
        (valueChange)="onChangeParentOption($event)"
        [prefixIcon]="'visible'"
        size="medium"
        [label]="parent?.isStatisticalCategory === true || allParentOptionsAreStatistical() ? ('COMPLAINT|Miejsce wystąpienia usterki - kategoria statystyczna' | translate) : ('COMPLAINT|Miejsce wystąpienia usterki' | translate)"
        [supportText]="first ? ('COMPLAINT|Wybór miejsca usterki pomoże przyśpieszyć proces obsługi, w przypadku wątpliwości pozostaw pole nieuzupełnione. Konsultant wypełni dane na podstawie zdjęć i opisu lub skontaktuje się z Tobą i zada dodatkowe pytania' | translate) : null"
    >
        <option [value]="null">{{ 'INTERFACE|Nie wybrano' | translate }}</option>
        <option
            *ngFor='let parentOption of parentOptions'
            [value]="parentOption.id"
        >
            {{ parentOption.name }}
        </option>
    </icc-select>
    <icc-icon></icc-icon>
</div>
<icc-complaint-position-configuration-select
    *ngIf="parent.children && childOptions?.length > 0"
    [(parent)]="parent.children"
    [parentOptions]="childOptions"
></icc-complaint-position-configuration-select>